import { filterObjectByKeys } from 'utils/helpers/filterObject'
import { AllAddressesKeys, defaultAllAddresses, defaultAddress, AddressInfo } from '../subtypes'
import { defaultEntity, Entity } from '../entity/entity'

const companyKeys = [
  'id',
  'apeCode',
  'commercialName',
  'commercialNameInt',
  'salesForceId',
  'name',
  'siret',
  'siren',
  'status',
  'roles',
  'vat',
  'cardCodeSapBuyer',
  'cardCodeSapSeller',
  'paymentType',
  'origin',
  'kyc',
  'isVatRecoverable',
  'isVatDepositExempt',
  'isCarProfessional',
  'representativeOf',
  'principalContact',
  'language',
  'calculationMethod',
  'segmentation',
  'outstandingAmount',
  'vpaRepresentative',
  'parentId',
  'location',
  'deliveryLocation',
  'invoicingLocation',
  'kbisFileStorageId',
  'documentFileStorageId',
  'createdOn',
  'createdBy',
  'children',
  'childrenCount',
  'documentsList',
  'modifications',
  'lastUpdatedAt',
  'createdDateTime',
] as const

type CompanyKeys = (typeof companyKeys)[number]

type Company = Pick<Entity, CompanyKeys>

const defaultCompany = filterObjectByKeys(
  defaultEntity,
  [...companyKeys] as Array<keyof Entity>,
  'include',
) as Company

// only the 'location' key is flattened
type CompanyFlattened = Omit<Company, AllAddressesKeys> & AddressInfo

type CompanyWithoutIdAndAddresses = Omit<Company, 'id' | AllAddressesKeys>

type CompanyBeforeCreate = Omit<Company, 'id'>
type CompanyBeforeCreateWithoutAddress = CompanyWithoutIdAndAddresses
type CompanyBeforeCreateFlattened = Omit<CompanyFlattened, 'id'>

const beforeCreateKeysToExclude: Array<CompanyKeys> = [
  'id',
  'location',
  'deliveryLocation',
  'invoicingLocation',
]

const defaultCompanyBeforeCreateWithoutAddress: CompanyBeforeCreateWithoutAddress = {
  ...(filterObjectByKeys(
    defaultCompany,
    beforeCreateKeysToExclude,
    'exclude',
  ) as CompanyWithoutIdAndAddresses),
}

const defaultCompanyBeforeCreate: CompanyBeforeCreate = {
  ...defaultCompanyBeforeCreateWithoutAddress,
  ...defaultAllAddresses,
}

const defaultCompanyBeforeCreateFlattened: CompanyBeforeCreateFlattened = {
  ...defaultCompanyBeforeCreateWithoutAddress,
  ...defaultAddress,
}

const defaultCompanyFlattened: CompanyFlattened = { id: '', ...defaultCompanyBeforeCreateFlattened }

export type { Company, CompanyFlattened, CompanyBeforeCreate, CompanyBeforeCreateFlattened }

export {
  defaultCompany,
  defaultCompanyFlattened,
  defaultCompanyBeforeCreate,
  defaultCompanyBeforeCreateFlattened,
}
